<div class="calendar-remarks-dialog" *ngIf="viewModel$ | async as viewModel">
  <div class="dialog-header">
    <h4>Calendar Remarks</h4>
    <p class="dialog-subtitle">Select a date range and add a remark to display on the schedule calendar.</p>
  </div>

  <div class="dialog-content">
    <div class="calendar-section">
      <p-calendar
        [ngModel]="viewModel.selectedDatesAsDate"
        (ngModelChange)="onDatesSelected($event)"
        selectionMode="range"
        [inline]="true"
        [showOtherMonths]="true"
        [viewDate]="viewModel.selectedDatesAsDate?.[0] ?? null"
        dateFormat="yy-mm-dd"
      ></p-calendar>
    </div>

    <div class="form-section">
      <div class="form-field">
        <label for="dispatch-remark-text">Remark Text</label>
        <input
          id="dispatch-remark-text"
          pInputText
          type="text"
          [ngModel]="viewModel.remarkText"
          (ngModelChange)="store.dispatch(actions.remarkTextInputChanged({ text: $event }))"
          placeholder="Enter remark text..."
          class="w-full"
        />
      </div>

      <div class="form-field">
        <label for="dispatch-remark-severity">Severity</label>
        <p-dropdown
          inputId="dispatch-remark-severity"
          [ngModel]="viewModel.remarkSeverity"
          (ngModelChange)="store.dispatch(actions.severityDropdownChanged({ severity: $event }))"
          [options]="severityOptions"
          optionLabel="label"
          optionValue="value"
          class="w-full"
        ></p-dropdown>
      </div>

      <div class="add-remark-row">
        <p-button
          [label]="viewModel.editingRemarkId ? 'Update Remark' : 'Add Remark'"
          icon="pi pi-plus"
          [outlined]="true"
          [disabled]="!viewModel.canAddRemark"
          (onClick)="store.dispatch(actions.addRemarkButtonClicked())"
          styleClass="w-full"
        ></p-button>
        <p-button
          *ngIf="viewModel.editingRemarkId"
          label="Cancel Edit"
          icon="pi pi-times"
          [text]="true"
          severity="secondary"
          (onClick)="store.dispatch(actions.editRemarkCancelled())"
        ></p-button>
      </div>
    </div>
  </div>

  <div class="remarks-list">
    <h5>Existing Remarks</h5>
    <p *ngIf="viewModel.loadingViewDates" class="remarks-loading">
      <i class="pi pi-spin pi-spinner"></i> Loading remarks...
    </p>
    <ng-container *ngIf="!viewModel.loadingViewDates">
      <div
        class="remark-item"
        *ngFor="let remark of viewModel.pendingRemarks"
        [class.editing]="remark.id === viewModel.editingRemarkId"
      >
        <p-tag
          [severity]="remark.severity"
          [value]="remark.date"
          styleClass="remark-date-tag"
        ></p-tag>
        <span class="remark-text">{{ remark.text }}</span>
        <div class="remark-actions">
          <p-button
            icon="pi pi-pencil"
            [text]="true"
            size="small"
            [attr.aria-label]="'Edit remark'"
            (onClick)="store.dispatch(actions.editRemarkButtonClicked({ remarkId: remark.id }))"
            pTooltip="Edit"
          ></p-button>
          <p-button
            icon="pi pi-trash"
            [text]="true"
            [attr.aria-label]="'Delete remark'"
            size="small"
            severity="danger"
            (onClick)="store.dispatch(actions.deleteRemarkButtonClicked({ remarkId: remark.id }))"
            pTooltip="Delete"
          ></p-button>
        </div>
      </div>
      <p
        class="no-remarks"
        *ngIf="!viewModel.pendingRemarks.length"
      >No remarks for selected dates.</p>
    </ng-container>
  </div>

  <div class="dialog-footer">
    <p-button
      label="Cancel"
      [outlined]="true"
      (onClick)="store.dispatch(actions.cancelButtonClicked())"
    ></p-button>
    <p-button
      label="Save"
      icon="pi pi-check"
      [loading]="viewModel.saving"
      (onClick)="store.dispatch(actions.saveButtonClicked())"
    ></p-button>
  </div>
</div>
